export default "__VITE_ASSET__CKUAwyBr__"